export enum EmailValidationState {
    VALID = 'valid',
    INVALID_EMAIL = 'invalid_email',
    MISMATCHED_EMAIL = 'mismatched_email',
}
